<template>
  <div class="setting">
    <div class="setting-item eprint-result">
      <h2 class="eprint_logo_block">
        <img src="/static/img/eprint/eprint-logo.png" class="eprint_logo" />
      </h2>
      <p class="mb-20px">
        <span class="font-weight-bold">
          お近くのコンビニのマルチコピー機にQRコード（二次元コード）をかざすと、書類がプリントできます。
        </span>
        eプリントサービスにて下記のコンテンツ番号を入力しても、決済・印刷することができます。
      </p>
      <div class="convenience-store-tabs">
        <div v-if="!session.isPrePayment" class="store-tabs">
          <el-button
            :class="[
              'tab-button',
              { active: session.selectedStore === 'seven' }
            ]"
            @click="selectStore('seven')"
          >
            セブンイレブン
          </el-button>
          <el-button
            :class="[
              'tab-button',
              { active: session.selectedStore === 'others' }
            ]"
            @click="selectStore('others')"
          >
            ファミリーマート・ローソン・ミニストップ・ポプラ
          </el-button>
        </div>
        <EprintQrCode />
      </div>
      <div class="printservice_block">
        <p class="printservice_number">
          コンテンツ番号：{{ session.eprintContentsCode }}
        </p>
        <p class="printservice_center">
          有効期限：{{ session.expirationDate }}まで
        </p>
      </div>
      <p style="margin: 30px 0; font-size: 14px">
        アカウントのメールアドレスにコンテンツ番号とQRコードをお送りしました。お確かめの上、コンビニにて印刷してください。
      </p>
      <EprintStoreMap />
      <el-collapse v-model="session.downloadActiveCollapses">
        <el-collapse-item title="※利用時の注意事項" name="backup">
          <div class="el-collapse-item__content">
            <ul class="collapse-list">
              <li>
                有効期限が過ぎた場合やコンテンツ番号を忘れた場合は再度コンビニ印刷を行ってください。
              </li>
              <li>
                ローソン・ファミリーマート以外のコンビニについては、10分程お時間がかかります。「販売終了もしくは、商品番号の入力が誤っている可能性があります。商品番号をご確認してください。」が表示された場合、少し時間を空けて再度ご入力をお試しください。
              </li>
            </ul>
          </div>
        </el-collapse-item>
      </el-collapse>
      <div class="printservice_memo_block">
        <a
          href="https://www.e-printservice.net/shohin/yagish"
          id="footer-link-eprint"
          target="_blank"
          rel="nofollow"
          class="external-link printservice_memo"
          >※コンテンツ番号の利用方法を確認する</a
        >
      </div>
      <div v-if="!session.isPrePayment" class="payment-change-button-container">
        <el-button
          type="primary"
          class="payment-change-button"
          @click="actions.changePaymentMethod"
        >
          決済方法を変更する
        </el-button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import EprintQrCode from '@/components/format-edit/eprint/EprintQrCode.vue'
import EprintStoreMap from '@/components/format-edit/eprint/EprintStoreMap.vue'
import {
  useEprintActions,
  useEprintSession
} from '@/composables/format-edit/useEprintSession'

const session = useEprintSession()
const actions = useEprintActions()

function selectStore(store: string) {
  session.isQRCodeLoaded = false
  session.qrCodeError = false
  session.qrCodeRetryCount = 0
  session.selectedStore = store
}
</script>
